import { Logo, BrandWordmark } from "./Logo";
import { ExternalLink } from "lucide-react";
import { useLang } from "../context/LangContext";

const OFFICIAL_URL = "https://holylandaward.iarc.org/";
const PRIVACY_URL = "https://award-mobile.emergent.host/api/legal/privacy";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-white/5 bg-[#13131A] py-16 px-6 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-soft opacity-50" />
      <div className="relative max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <Logo size="lg" />
            <p className="mt-5 text-white/55 max-w-md leading-relaxed text-sm">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              {t("footer.resources")}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={OFFICIAL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-official-link"
                  className="text-white/65 hover:text-[#FF6B35] transition-colors inline-flex items-center gap-1.5"
                >
                  {t("footer.official_link")}
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="#download"
                  className="text-white/65 hover:text-[#007AFF] transition-colors"
                >
                  {t("footer.download_link")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              {t("footer.legal")}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={PRIVACY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-privacy-link"
                  className="text-white/65 hover:text-white transition-colors inline-flex items-center gap-1.5"
                >
                  {t("footer.privacy")}
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/65 hover:text-white transition-colors"
                >
                  {t("footer.terms")}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/65 hover:text-white transition-colors"
                >
                  {t("footer.support")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <BrandWordmark className="text-xl md:text-2xl text-white/15" />
          <p className="text-xs text-white/40">{t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
};
